import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toHandlers as _toHandlers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"vertical-align":"middle"} }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"vertical-align":"middle"} }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { style: {"height":"100%"} }
const _hoisted_8 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_9 = {
  key: 0,
  class: "ad-banner"
}
const _hoisted_10 = {
  key: 1,
  class: "ad-banner"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_program_info_stats = _resolveComponent("program-info-stats")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ProgramItemContent = _resolveComponent("ProgramItemContent")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_program_issue_report_modal = _resolveComponent("program-issue-report-modal")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        (_ctx.isAB3 || !_ctx.singleSelectMode)
          ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_buttons, { slot: "start" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      slot: "icon-only",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmSelect(true)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_title, { style: {"padding-left":"16px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => [
                        (_ctx.isAB3)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_1, [
                              _createElementVNode("b", null, [
                                _createElementVNode("span", _hoisted_2, [
                                  _createVNode(_component_ion_icon, { icon: _ctx.thumbsUpOutline }, null, 8, ["icon"])
                                ]),
                                _cache[12] || (_cache[12] = _createTextVNode("  2+ programs"))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("h2", _hoisted_3, [
                              _createElementVNode("b", null, [
                                _createElementVNode("span", _hoisted_4, [
                                  _createVNode(_component_ion_icon, { icon: _ctx.thumbsUpOutline }, null, 8, ["icon"])
                                ]),
                                _cache[13] || (_cache[13] = _createTextVNode("  20 programs"))
                              ])
                            ])),
                        (_ctx.targetDiscipline)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "for " + _toDisplayString(_ctx.targetDiscipline?.name), 1))
                          : (!_ctx.isAB3)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.chosenPrograms.length) + "/20 selected", 1))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.takenActions)
                  ? (_openBlock(), _createBlock(_component_ion_buttons, {
                      key: 0,
                      slot: "end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          fill: "solid",
                          color: "success",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmSelect()))
                        }, {
                          default: _withCtx(() => [
                            _cache[14] || (_cache[14] = _createTextVNode(" Save ")),
                            _createVNode(_component_ion_icon, {
                              slot: "end",
                              icon: _ctx.checkmark
                            }, null, 8, ["icon"])
                          ]),
                          _: 1,
                          __: [14]
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_searchbar, {
              id: "keyword-searchbar",
              style: {"padding-bottom":"1px"},
              mode: "md",
              modelValue: _ctx.searchKeyword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchKeyword) = $event)),
              placeholder: _ctx.t('search'),
              onIonFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSearching = true)),
              onIonCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isSearching = false)),
              onKeyup: _cache[5] || (_cache[5] = _withKeys((e) => e.target.blur(), ["enter"])),
              "show-cancel-button": "always"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.isSearching]
        ]),
        _createElementVNode("div", _hoisted_7, [
          (!_ctx.delayLoading && _ctx.filteredPrograms().length > 0)
            ? (_openBlock(), _createBlock(_component_swiper, {
                key: 0,
                class: "program-slides",
                id: "card-swiper-slides",
                grabCursor: true,
                navigation: true,
                modules: _ctx.modules,
                virtual: { enabled: true }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPrograms(), (program) => {
                    return (_openBlock(), _createBlock(_component_swiper_slide, {
                      class: "program-slide",
                      key: program.id,
                      "data-program-id": program.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_program_info_stats, {
                            program: program,
                            showNames: false,
                            showTargetScores: true,
                            showProgramAdmissionData: false,
                            showWebsiteButtons: false,
                            transparent: true,
                            targetUser: _ctx.targetUser
                          }, null, 8, ["program", "targetUser"])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["program-slide-upper-section", { 'highlighted-border': _ctx.isSelected(program) }])
                        }, [
                          _createVNode(_component_ion_row, { style: {"width":"100%"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_program_info_stats, {
                                program: program,
                                showProgramAdmissionData: true,
                                targetUser: _ctx.targetUser
                              }, null, 8, ["program", "targetUser"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_row, { style: {"align-items":"center"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                                default: _withCtx(() => [
                                  (program?.cardSlideImgLink)
                                    ? (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 0,
                                        class: "no-text-transform",
                                        size: "small",
                                        color: "danger",
                                        onClick: ($event: any) => (_ctx.openImageModal(program.cardSlideImgLink))
                                      }, {
                                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                                          _createTextVNode(" Highlights ")
                                        ])),
                                        _: 2,
                                        __: [15]
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  (_ctx.singleSelectMode && _ctx.isSelected(program) && program.id != _ctx.showFirstProgramId)
                                    ? (_openBlock(), _createBlock(_component_ion_fab_button, {
                                        key: 0,
                                        style: {"margin":"0 auto"},
                                        size: "large",
                                        color: "primary"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getBandLabel(_ctx.chosenPrograms.findIndex(p => p.id == program.id))), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (_openBlock(), _createBlock(_component_ion_fab_button, _mergeProps({
                                        key: 1,
                                        style: {"margin":"0 auto"},
                                        size: "large",
                                        color: "primary"
                                      }, _toHandlers({ [_ctx.isMobileWeb() ? 'touchstart' : 'click']: () => { _ctx.onThumbsUp(program) } }), {
                                        disabled: !_ctx.passProgramElectiveRequirements(program)
                                      }), {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            size: "large",
                                            icon: _ctx.isSelected(program) ? _ctx.thumbsUp : _ctx.thumbsUpOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1040, ["disabled"]))
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                                default: _withCtx(() => [
                                  (_ctx.allClientProgramIds.includes(program.id))
                                    ? (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 0,
                                        class: "no-text-transform",
                                        size: "small",
                                        color: "primary",
                                        style: {"margin":"0","height":"36px","font-size":"0.75em"},
                                        onClick: ($event: any) => (_ctx.openAIProfessionDeckModal(program.id))
                                      }, {
                                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                                          _createTextVNode(" Careers ")
                                        ])),
                                        _: 2,
                                        __: [16]
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_col, { size: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ProgramItemContent, {
                                    item: program,
                                    hideNames: true,
                                    fromDeckView: true,
                                    showRecommendedEvents: program.id == 161
                                  }, null, 8, ["item", "showRecommendedEvents"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_col, {
                                size: "12",
                                class: "ion-text-center"
                              })
                            ]),
                            _: 2
                          }, 1024)
                        ], 2),
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          color: "medium",
                          size: "small",
                          onClick: _withModifiers(($event: any) => (undefined), ["stop"]),
                          href: _ctx.loggedInUser?.waGroupLink,
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "start",
                              icon: _ctx.flagOutline
                            }, null, 8, ["icon"]),
                            _cache[17] || (_cache[17] = _createTextVNode(" 有唔妥？即時cap圖/錄音俾我哋！ ")),
                            _createVNode(_component_ion_icon, {
                              slot: "end",
                              icon: _ctx.logoWhatsapp
                            }, null, 8, ["icon"])
                          ]),
                          _: 1,
                          __: [17]
                        }, 8, ["href"])
                      ]),
                      _: 2
                    }, 1032, ["data-program-id"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modules"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_ion_modal, {
          "is-open": _ctx.showReportModal,
          onDidDismiss: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showReportModal = false))
        }, {
          default: _withCtx(() => [
            (_ctx.selectedProgramForReport)
              ? (_openBlock(), _createBlock(_component_program_issue_report_modal, {
                  key: 0,
                  program: _ctx.selectedProgramForReport
                }, null, 8, ["program"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["is-open"])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_ion_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { style: {"--min-height":"24px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  class: "nav-category-btn",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmSelect(true)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      size: "small",
                      slot: "icon-only",
                      icon: _ctx.arrowBack
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_segment, {
              class: "filter-group-segment",
              mode: "ios",
              modelValue: _ctx.selectedFilterGroup,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedFilterGroup) = $event)),
              scrollable: ""
            }, {
              default: _withCtx(() => [
                (!_ctx.targetDiscipline)
                  ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                      key: 0,
                      value: "disciplines"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createTextVNode("Disciplines")
                          ])),
                          _: 1,
                          __: [18]
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_segment_button, { value: "institutions" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createTextVNode("Institutions")
                      ])),
                      _: 1,
                      __: [19]
                    })
                  ]),
                  _: 1
                }),
                (!_ctx.singleSelectMode && _ctx.userPrograms.some(ud => ud.reaction == 'like'))
                  ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                      key: 1,
                      value: "like"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          size: "small",
                          icon: _ctx.thumbsUpOutline
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_segment_button, { value: "search" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_ripple_effect),
                    _createVNode(_component_ion_icon, {
                      size: "small",
                      icon: _ctx.search
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_ion_toolbar, { class: "material-div" }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_chip, {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedOption = 'dislike')),
                  class: _normalizeClass({ 'active-tag': _ctx.selectedOption == 'dislike' })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      color: _ctx.selectedOption == 'dislike' ? 'light' : 'dark',
                      style: {"margin-inline-start":"0"},
                      icon: _ctx.thumbsDownOutline
                    }, null, 8, ["color", "icon"])
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_ion_chip, {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedOption = 'like')),
                  class: _normalizeClass({ 'active-tag': _ctx.selectedOption == 'like' })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      color: _ctx.selectedOption == 'like' ? 'light' : 'dark',
                      style: {"margin-inline-start":"0"},
                      icon: _ctx.thumbsUpOutline
                    }, null, 8, ["color", "icon"])
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.selectedFilterGroup == 'myChoices']
            ]),
            _withDirectives(_createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                (_ctx.user.isAdmin && _ctx.relatedAdvBanner)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (!_ctx.relatedAdvBanner.bannerImgLink)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Your department's advertisement "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("img", {
                              src: _ctx.getProxyImgLink(_ctx.relatedAdvBanner.bannerImgLink)
                            }, null, 8, _hoisted_11)
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isAB3)
                  ? (_openBlock(), _createBlock(_component_ion_chip, {
                      key: 1,
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedOption = 'highlight')),
                      class: _normalizeClass({ 'active-tag': _ctx.selectedOption == 'highlight' })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createTextVNode("Highlight")
                          ])),
                          _: 1,
                          __: [20]
                        })
                      ]),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disciplineGroups, (dg) => {
                  return (_openBlock(), _createBlock(_component_ion_chip, {
                    key: dg.id,
                    onClick: ($event: any) => (_ctx.selectedOption = dg),
                    class: _normalizeClass({ 'active-tag': _ctx.selectedOption.id == dg.id })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(dg.name) + " " + _toDisplayString(dg.nameChi), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "class"]))
                }), 128)),
                _cache[21] || (_cache[21] = _createElementVNode("hr", null, null, -1)),
                (_ctx.selectedOption.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disciplines.filter(d => d.disciplineGroupId == _ctx.selectedOption.id), (dis) => {
                        return (_openBlock(), _createBlock(_component_ion_chip, {
                          outline: "",
                          key: dis.id,
                          onClick: ($event: any) => (_ctx.nestedOption = dis.id),
                          class: _normalizeClass({ 'active-tag-primary': _ctx.nestedOption == dis.id })
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(dis.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "class"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1,
              __: [21]
            }, 512), [
              [_vShow, _ctx.selectedFilterGroup == 'disciplines']
            ]),
            _withDirectives(_createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedInstitutions, (inst) => {
                  return (_openBlock(), _createBlock(_component_ion_chip, {
                    key: inst.id,
                    onClick: ($event: any) => (_ctx.selectedOption = inst),
                    class: _normalizeClass({ 'active-tag': _ctx.selectedOption.id == inst.id })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(inst.nameShort), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "class"]))
                }), 128)),
                _cache[22] || (_cache[22] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disciplineGroups, (dg) => {
                    return (_openBlock(), _createBlock(_component_ion_chip, {
                      outline: "",
                      key: dg.id,
                      onClick: ($event: any) => (_ctx.nestedOption = dg.id),
                      class: _normalizeClass({ 'active-tag-primary': _ctx.nestedOption == dg.id })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(dg.name) + " " + _toDisplayString(dg.nameChi), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class"]))
                  }), 128))
                ])
              ]),
              _: 1,
              __: [22]
            }, 512), [
              [_vShow, _ctx.selectedFilterGroup == 'institutions']
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, !_ctx.isSearching]
    ])
  ], 64))
}